import { RouteErrorFallback } from '@components/errors/RouteErrorFallback'
import { studentInfoQueryOptions } from '@features/student-page/queries'
import { studentAbsencesQueryOptions } from '@features/student-page/sub-features/student-absences/queries'
import { studentAuthVsUnauthQueryOptions } from '@features/student-page/sub-features/student-auth-v-unauth/queries'
import { studentLatesQueryOptions } from '@features/student-page/sub-features/student-lates/queries'
import { studentMonthAttendanceQueryOptions } from '@features/student-page/sub-features/student-month-attendance/queries'
import { studentYearPeriodAttendanceQueryOptions } from '@features/student-page/sub-features/student-year-period-attendance/queries'
import { StudentAttendancePage } from '@features/student-page/components/StudentAttendancePage'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/students/$studentNo/attendance')({
    component: RouteComponent,
    loader: ({ params, context }) => {
        void Promise.all([
            context.queryClient.ensureQueryData(studentInfoQueryOptions(params.studentNo)),
            context.queryClient.ensureQueryData(studentAbsencesQueryOptions(params.studentNo)),
            context.queryClient.ensureQueryData(studentAuthVsUnauthQueryOptions(params.studentNo)),
            context.queryClient.ensureQueryData(studentLatesQueryOptions(params.studentNo)),
            context.queryClient.ensureQueryData(studentYearPeriodAttendanceQueryOptions(params.studentNo)),
            context.queryClient.ensureQueryData(studentMonthAttendanceQueryOptions(params.studentNo)),
        ])
    },
    staticData: {
        crumb: {
            label: 'Attendance',
        },
    },
    errorComponent: ({ error, reset }) => (
        <RouteErrorFallback
            error={error}
            onRetry={reset}
            title="An error occurred"
            description="There was an error loading attendance."
        />
    ),
})

function RouteComponent() {
    const { studentNo } = Route.useParams()

    return <StudentAttendancePage studentNo={studentNo} />
}
